/*
 * @Description: 
 * @Autor: lkz
 * @Date: 2020-09-24 18:35:25
 * @LastEditors: lkz
 * @LastEditTime: 2020-09-24 20:58:50
 */
/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/miniapps',
    name: '/robotConfig',
    meta: {
      title: '聊天窗管理'
    },
    component: () =>
      import( /* webpackChunkName: "example-robotConfig" */ '../views/miniapps/drp/robotConfig.vue')
  },
  {
    path: '/miniapps/edit',
    name: '/robotConfigEdit',
    meta: {
      title: '聊天窗编辑'
    },
    component: () =>
      import( /* webpackChunkName: "example-robotConfig" */ '../views/miniapps/drp/robotConfigEdit.vue')
  }
]